import { createStore } from "vuex";
import { sharedModule } from "search-observe-app";
import packageJson from "../../package.json";

const store = createStore({
  modules: {
    shared: sharedModule,
    app: {
      namespaced: true,
      state: () => ({
        pkg: packageJson,
        siteUrl: "https://honu.abrinc.com",

        refTables: {
          ref_lighting: [],
          ref_observer: [],
          ref_sex: [],
          ref_turtle_species: [],
          ref_predator_species: [],
          ref_photo_type: [],
          ref_breadcrumb_turtle_location: [],
          ref_ground_cover: [],
          ref_structure_type: [],
        },
        dataTables: {
          survey_effort_turtle: [],
          survey_breadcrumb_turtle: [],
          survey_turtle: [],
          survey_predator: [],
          survey_photo_turtle: [],
          survey_photo_predator: [],
        },
        tablePositions: {
          survey_effort_turtle: -1,
          survey_breadcrumb_turtle: -1,
          survey_turtle: -1,
          survey_predator: -1,
          survey_photo_turtle: -1,
          survey_photo_predator: -1,
        },
        views: {
          recent_survey_effort: [],
          recent_survey_turtle: [],
          recent_survey_predator: [],
        },
      }),
      mutations: {},
      getters: {},
    },
  },
});

//store.registerModule("shared", sharedModule);
export default store;
